import React from 'react';

import classes from './CompareValueCell.module.scss';
import { getRoundedNumber } from '../../../../../../../../shared/utils/mathUtils/getRoundedNumber/getRoundedNumber';
import { GridTableCell } from '../../../../../../../../shared/components/table-components/GridTableCell/GridTableCell';

type CompareValueCellProps = {
  currentValue: number;
  previousValue: number;
  unit: string;
  /**
   * If true, positive change is good, negative change is bad
   * If false, positive change is bad, negative change is good
   * @default false - show error color for positive value, success color for negative value
   */
  gainIsGood?: boolean;
  /**
   * If true, show color indicator
   * @default true
   */
  showColorIndicator?: boolean;
  showUnitNearValue?: boolean;
};

const CompareValueCell = ({
  currentValue,
  previousValue,
  unit,
  gainIsGood = false,
  showColorIndicator = true,
  showUnitNearValue = false,
}: CompareValueCellProps) => {
  const difference = currentValue - previousValue;

  const isPositive = difference > 0;
  const isNegative = difference < 0;
  const isZero = difference === 0;

  const getColor = () => {
    if (!showColorIndicator || isZero) {
      return undefined;
    }
    if (gainIsGood) {
      return isPositive ? 'var(--success-500)' : 'var(--error-600)';
    } else {
      return isNegative ? 'var(--success-500)' : 'var(--error-600)';
    }
  };

  const formatDifference = () => {
    if (isZero) {
      return `${difference} ${unit}`;
    }

    const sign = isPositive ? '+' : '-';
    const roundedDifference = getRoundedNumber(Math.abs(difference), 1);

    return `${sign}${roundedDifference} ${unit}`;
  };

  return (
    <GridTableCell className={classes.compareValueCell}>
      <span>
        {currentValue}
        {showUnitNearValue && unit}
      </span>
      <span className={classes.difference} style={{ color: getColor() }}>
        {formatDifference()}
      </span>
    </GridTableCell>
  );
};

export { CompareValueCell };
